var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.displayAccordion
    ? _c(
        "div",
        { staticClass: "product-accordions" },
        [
          _vm.benefitsAvailable ||
          _vm.routineAvailable ||
          _vm.ingredientsAvailable
            ? _c(
                "accordion-group",
                [
                  _vm.benefitsAvailable
                    ? _c(
                        "accordion",
                        { attrs: { heading: _vm.benefitsHeading } },
                        [
                          _c("strong", {
                            domProps: {
                              innerHTML: _vm._s(
                                this.product.customFields.benefits_subheading
                              )
                            }
                          }),
                          _c("div", {
                            domProps: {
                              innerHTML: _vm._s(
                                this.product.customFields
                                  .product_benefits_content
                              )
                            }
                          })
                        ]
                      )
                    : _vm._e(),
                  _vm.routineAvailable
                    ? _c(
                        "accordion",
                        { attrs: { heading: _vm.routineHeading } },
                        [
                          _c("strong", {
                            domProps: {
                              innerHTML: _vm._s(
                                this.product.customFields.how_to_use_subheading
                              )
                            }
                          }),
                          _c("div", {
                            domProps: {
                              innerHTML: _vm._s(
                                this.product.customFields.how_to_use_content
                              )
                            }
                          }),
                          _c("div", {
                            domProps: {
                              innerHTML: _vm._s(
                                this.product.customFields.how_to_use_info
                              )
                            }
                          }),
                          _c("div", {
                            domProps: {
                              innerHTML: _vm._s(
                                this.product.customFields.how_to_use_details
                              )
                            }
                          })
                        ]
                      )
                    : _vm._e(),
                  _vm.ingredientsAvailable
                    ? _c(
                        "accordion",
                        { attrs: { heading: _vm.ingredientHeading } },
                        [
                          _c("strong", {
                            domProps: {
                              innerHTML: _vm._s(
                                this.product.customFields.ingredients_subheading
                              )
                            }
                          }),
                          _c("div", {
                            domProps: {
                              innerHTML: _vm._s(
                                this.product.customFields
                                  .ingredients_accordion_content[0]
                              )
                            }
                          })
                        ]
                      )
                    : _vm._e()
                ],
                1
              )
            : _vm._e(),
          this.product.customFields.benefits_disclaimer
            ? _c("div", {
                staticClass: "product-accordions__disclaimer",
                domProps: {
                  innerHTML: _vm._s(
                    this.product.customFields.benefits_disclaimer
                  )
                }
              })
            : _vm._e()
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }